import { render, staticRenderFns } from "./ToolProducts.vue?vue&type=template&id=e35f7a76"
import script from "./ToolProducts.vue?vue&type=script&lang=js"
export * from "./ToolProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports